import { publicApi } from '@/api/public'
import { favoritesApi } from '@/api/favorites'
import { online } from '@/composables/useOnline'

// Proaktiv offline-cache: henter det appen skal bruge offline, så service-workeren gemmer
// det (public-reads = NetworkFirst, hero = CacheFirst, /api/user + /.auth/me = NetworkFirst).
// Kaldes når appen starter og når den lukkes/går i baggrunden — så data altid er gemt ned.

let running = false
let lastRun = 0
const MIN_INTERVAL_MS = 5 * 60 * 1000 // undgå at hamre ved hvert app-skift

// force springer throttlingen over (bruges ikke pt., men gør intentionen tydelig).
export async function prefetchForOffline(force = false): Promise<void> {
  if (running || !online.value) return
  if (!force && Date.now() - lastRun < MIN_INTERVAL_MS) return
  running = true
  lastRun = Date.now()
  try {
    // Auth-principal + favoritter (warmer 'auth'- og 'api-user'-cachene → Favoritter virker offline).
    await Promise.allSettled([fetch('/.auth/me'), favoritesApi.list()])

    // Stedliste + per-sted detalje/prognose/hero, så ethvert sted kan åbnes offline.
    const sites = await publicApi.listSites()
    await Promise.allSettled(
      sites.flatMap((s) => {
        const jobs: Promise<unknown>[] = [publicApi.getSite(s.id), publicApi.getForecast(s.id)]
        if (s.heroImageUrl) jobs.push(fetch(s.heroImageUrl))
        return jobs
      }),
    )
  } catch {
    /* best-effort — offline-cachen er en bonus, aldrig blokerende */
  } finally {
    running = false
  }
}
